<template>
    <v-row>
        <v-col cols="12" xs="12" sm="3" md="3">
            <v-switch
                label="Show Label"
                v-model="componentValues.is_show_label"
                hide-details
                class="mr-4 mt-2"
                dense
            ></v-switch>
        </v-col>
        <v-col cols="12" xs="12" sm="2" md="2">
            <v-checkbox
                label="Hidden"
                v-model="componentValues.is_hidden"
                outlined
                hide-details
                dense
                class="mt-2"
            ></v-checkbox>
        </v-col>
        <v-col cols="12" xs="12" sm="7" md="7" class="d-flex">
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        label="Default Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        dense
                        clearable
                        class="mt-2"
                        v-bind="attrs"
                        v-on="on"
                        :value="formatDate"
                        @click:clear="clearDate"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="componentValues.component_default_value"
                    @input="menu2 = false"
                ></v-date-picker>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>
import moment from 'moment';
export default {
    name: 'Date',
    props: {
        isHidden: Boolean,
        isShowLabel: Boolean,
        defaultValue: String,
    },
    data() {
        return {
            menu2: false,
            componentValues: {
                component_default_value: null,
                is_show_label: false,
                is_hidden: true,
            },
        };
    },
    methods: {
        clearDate() {
            this.componentValues.component_default_value = null;
        },
        setInitials() {
            this.componentValues.component_default_value = this.defaultValue
                ? this.defaultValue
                : null;
            this.componentValues.is_show_label = this.isShowLabel ? this.isShowLabel : null;
            this.componentValues.is_hidden = this.isHidden ? this.isHidden : null;
        },
    },
    watch: {
        'componentValues.component_default_value'() {
            this.$emit('update-values', this.componentValues);
        },
        'componentValues.is_show_label'() {
            this.$emit('update-values', this.componentValues);
        },
        'componentValues.is_hidden'() {
            this.$emit('update-values', this.componentValues);
        },
    },
    mounted() {
        this.setInitials();
    },
    computed: {
        formatDate() {
            return this.componentValues.component_default_value
                ? moment(this.componentValues.component_default_value).format('DD-MM-YYYY')
                : '';
        },
    },
};
</script>

<style scoped></style>
